import React, { PropsWithChildren } from "react";
import LeftAuthPanel from "@/components/LeftAuthPanel";

const AuthLayout: React.FC<PropsWithChildren> = (props) => {
  return (
    <main
      className="min-w-screen flex flex-col-reverse items-start bg-primary md:flex-row md:overflow-hidden"
      style={{ height: "calc(100vh * 1.24)" }}
    >
      <LeftAuthPanel />
      <div className="flex h-full w-full flex-col justify-center overflow-hidden bg-white px-5 pt-10 dark:bg-theme-color md:min-h-screen md:w-1/2 md:p-20">
        {props?.children}
      </div>
    </main>
  );
};

export default AuthLayout;
